// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__356iK","actions":"GroupTable_actions__2Yyt4","deleteModalFooter":"GroupTable_deleteModalFooter__1LsYe"};